import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentFooterComponent } from './component-footer.component';
import { RouterModule } from '@angular/router';
import { PipeModule } from 'src/app/pipe/pipe.module';



@NgModule({
  declarations: [
    ComponentFooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipeModule
  ],
  exports: [
    ComponentFooterComponent
  ]
})
export class ComponentFooterModule { }
